import { render } from "./memberInfo.vue?vue&type=template&id=6f6c4390"
import script from "./memberInfo.vue?vue&type=script&lang=js"
export * from "./memberInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__